const pageNames = {
    car: {
        start: 'quote start',
        overnight_parking_type: 'parking type'
    },
    home_contents: {
        start: 'quote start',
        occupancy: 'occupancy details',
        your_details: 'policy holder'
    }
};

export default pageNames;
